module.exports = __webpack_public_path__ + "static/media/kim-win.cae90d07.png";